import {ActionsRow, FixedDropDownButton, i18n, Icon} from 'mc/lib';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {CardBlock, DropdownItem} from 'reactstrap';

export default class Dokument extends PureComponent {

    static propTypes = {
        dokument: PropTypes.object.isRequired,
        onDelete: PropTypes.func,
    };

    handleDelete = () => {
        const {dokument, onDelete} = this.props;
        onDelete(dokument);
    };

    getLinkUrl() {
        const {dokument: {id, idLokalita, idZadost, soubor}} = this.props;
        if (soubor) {
            return URL.createObjectURL(soubor);
        }
        return `${serverContextPath}/api/zadost/${idZadost}/lokalita/${idLokalita}/dokument/${id}/soubor`;
    }

    renderActions() {
        const {onDelete} = this.props;
        return (
            <FixedDropDownButton noCaret color="action action-hover" title={<Icon icon="ellipsis-v"/>}>
                {<DropdownItem onClick={this.handleOpen}>{i18n('global.open')}</DropdownItem>}
                {onDelete && <DropdownItem onClick={this.handleDelete}>{i18n('global.delete')}</DropdownItem>}
            </FixedDropDownButton>
        );
    }

    render() {
        const {dokument} = this.props;
        const {nazev} = dokument;
        return (
            <CardBlock>
                <ActionsRow actions={this.renderActions()} noCenter>
                    <a href={this.getLinkUrl()} target="_blank">
                        <Icon icon="file"/> {nazev}
                    </a>
                </ActionsRow>
            </CardBlock>
        );
    }
}
